import { createAction } from 'redux-actions'

const CLIPBOARD_ENABLE = 'clipboard/enable'
const CLIPBOARD_DISABLE = 'clipboard/disable'
const CLIPBOARD_REMOTE_RECEIVE = 'clipboard/remote/receive'
const CLIPBOARD_REMOTE_RECEIVE_SYNC_DONE = 'clipboard/remote/receive/sync-done'
const CLIPBOARD_REMOTE_RECEIVE_SYNC_FAIL = 'clipboard/remote/receive/sync-fail'
const CLIPBOARD_REMOTE_SEND = 'clipboard/remote/send'
const CLIPBOARD_PASTE = 'clipboard/paste'
const CLIPBOARD_PASTE_FAIL = 'clipboard/paste/fail'
const CLIPBOARD_LOCAL_WRITE = 'clipboard/write'

export const clipboardEnable = createAction(CLIPBOARD_ENABLE)
export const clipboardDisable = createAction(CLIPBOARD_DISABLE)

export const clipboardPaste = createAction(CLIPBOARD_PASTE)
export const clipboardPasteFail = createAction(CLIPBOARD_PASTE_FAIL)

export const clipboardRemoteReceive = createAction(CLIPBOARD_REMOTE_RECEIVE)
export const clipboardRemoteReceiveSyncDone = createAction(CLIPBOARD_REMOTE_RECEIVE_SYNC_DONE)
export const clipboardRemoteReceiveSyncFail = createAction(CLIPBOARD_REMOTE_RECEIVE_SYNC_FAIL)
export const clipboardRemoteSend = createAction(CLIPBOARD_REMOTE_SEND)

export const clipboardLocalWrite = createAction(CLIPBOARD_LOCAL_WRITE)
